import { useSelector } from 'react-redux';
import { THEME } from '../pages/shop-setting/shop-theme/constant';
import { useMemo } from 'react';

const deepMerge = (base = {}, override = {}) => {
  const result = { ...base };
  for (const key in override) {
    const baseVal = base[key];
    const overrideVal = override[key];

    if (overrideVal && typeof overrideVal === 'object' && !Array.isArray(overrideVal)) {
      result[key] = deepMerge(baseVal || {}, overrideVal);
    } else if (overrideVal !== undefined && overrideVal !== null) {
      result[key] = overrideVal;
    }
  }
  return result;
};

const previewKeys = {
  navbar: 'THEME_NAVBAR_PREVIEW',
  sidebar: 'THEME_SIDEBAR_PREVIEW',
  profile: 'THEME_PROFILE_PREVIEW',
  mainheader: 'THEME_MAINHEADER_PREVIEW',
  main: 'THEME_MAIN_PREVIEW',
  regis: 'THEME_REGIS_PREVIEW',
  login: 'THEME_LOGIN_PREVIEW',
  custom: 'THEME_CUSTOM_PREVIEW'
};
const previews = Object.fromEntries(
  Object.entries(previewKeys).map(([key, sessionKey]) => [key, JSON.parse(sessionStorage.getItem(sessionKey))])
);

const DEFAULT_STYLE = {};

export const useCustomTheme = () => {
  const shopSetting = useSelector(state => state.auth.shopSetting);

  const { navbar, sidebar, profile, mainheader, main, regis, login, custom } = shopSetting || DEFAULT_STYLE;

  const STYLE = useMemo(
    () => ({
      navbar: deepMerge(THEME.navbar, previews.navbar || navbar || {}),
      sidebar: deepMerge(THEME.sidebar, previews.sidebar || sidebar || {}),
      profile: deepMerge(THEME.profile, previews.profile || profile || {}),
      mainheader: deepMerge(THEME.mainheader, previews.mainheader || mainheader || {}),
      main: deepMerge(THEME.main, previews.main || main || {}),
      regis: deepMerge(THEME.regis, previews.regis || regis || {}),
      login: deepMerge(THEME.login, previews.login || login || {}),
      custom: deepMerge(THEME.custom, previews.custom || custom || {})
    }),
    [navbar, sidebar, profile, mainheader, main, regis, login, custom]
  );

  return STYLE;
};

export const checkPreview = () => {
  const previewKeys = [
    'THEME_NAVBAR_PREVIEW',
    'THEME_SIDEBAR_PREVIEW',
    'THEME_PROFILE_PREVIEW',
    'THEME_MAINHEADER_PREVIEW',
    'THEME_MAIN_PREVIEW',
    'THEME_REGIS_PREVIEW',
    'THEME_LOGIN_PREVIEW',
    'THEME_CUSTOM_PREVIEW'
  ];

  return previewKeys.some(key => {
    try {
      return !!JSON.parse(sessionStorage.getItem(key));
    } catch {
      return false;
    }
  });
};
